// All application 'select' options (Combo values)

export const meritalStatus = ['נשואים', 'גרושים', 'חד-הורית', 'פרודים', 'אלמן/ה', 'ידועים בציבור', 'חיים יחד'] 
export const singleMeritalStatus = ["רווק/ה","נשואים","חיים יחד","פרוד/ה","גרוש/ה","אלמנ/ה", "ידוע/ה בציבור","מסורבת גט","עגונה","אחר"]
export const familyReferralStatus = ["התקבלה פניה. טרם התבצע בירור","ברור עם המשפחה","ברור עם גורם מפנה","קבלה לאינטייק","עברה לאינטייק",
                                "סיום. אין התאמה", "סיום. יש פוטנציאל", "סיום. המשפחה ויתרה"]
//export const familyReferralStatus = ["התקבלה פניה. טרם התבצע בירור","ברור עם המשפחה","ברור עם גורם מפנה","קבלה לאינטייק", 
//                        "עברה לאינטייק","התקבלה לתכנית", "סיום. אין התאמה", "סיום. יש פוטנציאל", "סיום. המשפחה ויתרה","לא מוגדר"]
export const familyIntakeStatus = ["באינטייק" , "מתעכב" ,"סיום אינטייק","קבלה לתכנית","פורשת","דחיה" ]
export const familyProgramStatus = ["בתכנית","בוגרת","מסיימת לפני הזמן בהסכמה","מסיימת בהחלטת התכנית","פורשת", "אחר"]
export const familyStatus = ["משתתפת", "בהפסקה","נושרת", "מסיימת בהסכמה לפני המועד","בוגרת", "אחר"]

export const ReferralMgrDecision = ["המשך ברור","קבלה לאינטייק","דחיה","העברה לתכנית אחרת","אחר"]
export const ReferralFamilyDecision = ["המשך לאינטייק", "ויתור", "המשך בירור", "אחר"]

export const teamMembers = ['איילת', 'אירית','אלה', 'הודיה', 'יניב','עידית', 'רחלי','רעות','מיטל'] // 'יהודית', 'עידית',

export const one2sevenB = ["כלל לא-1", "2","3", "4","5", "6","7"]
export const one2seven =  ["כלל לא-1", "2", "3", "4", "5", "6", "במידה רבה מאוד-7"]

export const one2sixTEXT = ["0-לא נדרש", "1-כלל לא", "2-במידה מעטה", "3-במידה בינונית", "4-במידה רבה", "5-רבה מאוד"]
export const one2six =     ["1-כלל לא", "2-במידה מעטה מאוד", "3- במידה מעטה","4-במידה בינונית", "5-במידה רבה", "6-במידה רבה מאוד"]

export const one2five =         ["1- כלל לא","2","3","4","5- במידה רבה מאוד"]
export const one2fiveTEXT =     ["1-כלל לא", "2-מעטה", "3-בינונית", "4-רבה", "5-רבה מאוד"]
export const one2fiveQuality =  ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"]
export const one2fiveLevel =    ["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"]

export const hard2easy = ["קשה מאוד","קשה","די קל","קל","קל מאוד"]

export const needLegal = ["לא","לא ברור","כן","אחר"]

export const needSolutionEntity = ["אב", "אם", "ילד", "בני זוג", "משפחה", "ילדים"]

export const taskArrayStatus = ["1 - לא התחיל", "2 - במידה מועטה", "3 - באמצע", "4 - במידה רבה", "5 - הושלם" ]

export const employQuality = ["תואם לכישורים", "במידה בינונית", "מתחת להשכלה וכישורים", "כלל לא"]

export const savingStatus = ["לא","לפעמים","כל חדש בקביעות","אחר"]

export const leaveEmpty = "לא מעוניינים- להשאיר ריק"
export const onlyYes =          ["כן"]
export const noYes =            ["כן", "לא"]
export const yesHesitateNo =    ["לא","מהססים","כן"]
// export const yesNo = ["כן" , "לא"],

export const noYesPratial =     ["כן", "לא", "חלקי"]
export const noneYes =          ["אין", "יש"]
export const noYesOther =       ["לא","כן","אחר"]
export const noYesWasInPast =   ["לא","כן","היתה בעבר"]
export const noYesWasInPastPlural =   ["לא","כן","היינו בעבר"]


export const noMaybeYes =       ["לא","אולי","כן"]
export const yesConsiderNo =    ["כן","שוקלים זאת","לא"]
export const socialSection =    ["חילוני","מסורתי","דתי","חרדי","אחר"]

export const rightsType =       ["תשלום", "מענק", "החזר", "הנחה", "הקלת מס", "פרויקט יעודי", "אחר"]

export const payPeriod =        ["חודשי", "דו חודשי", "רבעוני", "שנתי", "חד פעמי", "לא רלוונטי", "אחר"]

export const womanManBoth =     ["האשה", "הגבר", "שני בני הזוג"]

export const femaleMale =       ["נקבה","זכר"]
export const maleFemaleOther =  ["זכר","נקבה","אחר"]

export const kidParents =       ["לשני ההורים","לאמא","לאבא","להורים גרושים","אחר"]

export const kidMisgeret = ["מעון/ משפחתון","גן","אצל הסבתא","בית ספר יסודי","בית ספר חטיבת ביניים","בית ספר תיכון",
            "שרות צבאי","שרות לאומי", "לימודים בישיבה קטנה","לימודים בישיבה גבוהה","לימודים בישיבת הסדר",
            "לימודים במכינה קדם צבאית","לימודים בכולל","עובד","ללא מסגרת","אחר"]

export const incomeType = ["משכורת","הכנסה מעסק","סיוע בשכ''ד","קצבת ילדים","קצבת ילד נכה","מזונות","אבטלה",
            "נכות","השלמת הכנסה","הבטחת הכנסה","מס הכנסה שלילי- מענק עבודה","קצבת שארים","הכנסות מהון","תמיכה משפחה/חברים","מענק קרן הצדקה","אחר"]

export const expenseCategory = ["דיור","ארנונה","חשמל","מים","גז", "ניידים","אינטרנט","כבלים", "תחבורה/רכב", "ביגוד",
                            "מזון", "בריאות", "חינוך","חוגים", "פנאי", "מתנות", "שוטפות", "אחר"]

export const houseOwner = ["דירה בבעלותנו","אצל ההורים","דיור ציבורי","בשכירות","דמי מפתח", "סיוע בשכ''ד משרד השיכון","אחר"]
export const debtsRange = ["אין לנו חובות","עד 100,000 ש''ח","עד 250,000 ש''ח","עד 500,000 ש''ח","מעל 500,000 ש''ח"]

export const lawner = ["בנקים","משפחה","חברים","חוץ בנקאיים","שוק אפור","הוצאה לפועל","כונס נכסים","מועצה-חינוך","ארנונה","מים","חשמל","גז",
                        "מעונות", "עמידר", "שכ''ד","הלוואה-מקום עבודה","קרן הצדקה","גמ''ח","אחר"]

export const notEmpWorkBefore = ["כן, עבדתי מחוץ לבית","כן, עבדתי מהבית","גם וגם",
            "עד כה בעיקר למדתי (בתיכון, מכללה, אוניברסיטה)", "עד כה הייתי בשירות צבאי / לאומי / אזרחי",
            "עד כה הייתי עקר/ת בית", "לא עבדתי","אחר"]

export const employStatus = ["שכיר","עצמאי","גם שכיר וגם עצמאי","עבודה בשחור","גם שכיר וגם עבודה בשחור","עקר/ת בית",
                        "מובטל","פנסיונר","לא עובד עקב נכות מוכרת","בחופשת לידה","מקבל מלגת עבודה","אחר"]

export const employSocial = ["קבועה (גם אם אין קביעות)", "זמנית", "מזדמנת", "מועסקת במהלך השנה ומפוטרת בחדשי הקיץ"]

export const academicEducation =["הנדסאי","לימודים לתואר ראשון","תואר ראשון (בוגר)","לימודים לתואר שני"," (מוסמך)תואר שני",
                                "לימודים לתואר שלישי","בעל תואר דוקטור","מהנדס","רופא","אין השכלה","אחר"]

export const secularEducation = ["סמיכה לרבנות שכונה – ''יורה יורה''","סמיכה לרבנות עיר","משגיח כשרות","תעודת השכלה תורנית גבוהה",
                            "מוהל מוסמך","מוהל מומחה","סופר סת''ם","אין השכלה","אחר"]
                                
export const notEmpWorkDuration = ["עד חצי שנה","עד שנה","שנתיים עד 5 שנים","6-10 שנים","למעלה מ-10 שנים","אחר"]

export const oneTill4plus =     ["0","1","2","3","4+"]

export const oneTill8 =         ["1","2","3","4","5","6","7","8"]
export const oneTill12plus =    ["1","2","3","4","5","6","7","8","9","10","11","12+"]
export const yearsOfStudy = ["0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25"]

export const snapshotOptions = ['התחלה','מחצית','סיום']
export const snapshotExclude = ['id', 'intake_code', 'program_code', 'referral_code']
export const taskStatus = ["טרם החל","בביצוע - 25%","בביצוע - 50%","בביצוע - 75%","הסתיים","נדחה","בוטל","מתעכב"]

export const years2015_2026 = ["2015","2016","2017","2018","2019","2020","2021","2022","2023","2024","2025","2026"]

export const kupatHolim = ["מאוחדת","כללית","לאומית","מכבי","לא מבוטח בקופת חולים כלשהי","אחר"]
export const healthIssues = ["אין בעיות מיוחדות","יש מחלה כרונית","קיימות מגבלות פיזיות","קיימות בעיות בריאותיות אחרות","אחר"]
export const bltLevel = ["לא","כן, בדרגה של 60%","כן, בדרגה של 65%","כן, בדרגה של 74%","כן, בדרגה של 100%","אחר"]
export const btlAck = ["זמני","קבוע","אין הכרה","אחר"]

export const bagroot = ["בגרות מלאה","בגרות חלקית","אין"]

export const snapshotPhase = ["בהצטרפות לתכנית", "תמונת מצב התחלה", "תמונת מצב אמצע", "תמונת מצב סיום"]

export const employNewBuisness = ["מעוניין לפתוח עסק חדש","מעוניין להרחיב עסק קיים","לא מעוניין","אחר"]
export const employVolunteer = ["כן","לא מתנדב, וגם לא מעוניין בכך","מעוניין להתנדב אך לא עושה זאת בפועל","אחר"]

// Required fields
export const notRequired = 0
export const required = 1 // for all
export const postProgram = 2 // not required if family not in program now
//export const bothParents = 1
export const singleWoman = 3
export const singleMan = 4





